require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-how-secure-and-pci-compliant-is-shopify.json") })
        }
      }, "path---blog-how-secure-and-pci-compliant-is-shopify");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-how-secure-and-pci-compliant-is-shopify!./.cache/json/blog-how-secure-and-pci-compliant-is-shopify.json
// module id = 455
// module chunks = 231608221292675